export const statusFilters = [
    { value: 'Creating', color: '#254FE4', label: 'Creating' },
    { value: 'Opened', color: '#2491D8', label: 'Opened' },
    { value: 'Editing', color: '#24AE95', label: 'Editing' },
    { value: 'UploadingFiles', color: '#67BB46', label: 'Uploading files' },
    { value: 'WaitingForApprovalOfPostProduction', color: '#FEC92E', label: 'Waiting for post production approval' },
    { value: 'WaitingForApprovalOfAdvertisingAgency', color: '#F59023', label: 'Waiting for ad agency approval' },
    { value: 'ApprovedAndSentToBroadcaster', color: '#F04422', label: 'Sent and waiting for download' },
    { value: 'DownloadedByBroadcaster', color: '#E4006E', label: 'Downloaded by broadcaster' },
    { value: 'DownloadedByAllBroadcasters', color: '#E4006E', label: 'Downloaded by all broadcasters' },
    { value: 'Closed', color: '#B20EB5', label: 'Closed' },
    { value: 'Rejected', color: '#797979', label: 'Rejected' },
    { value: 'Cancelled', color: '#FF0000', label: 'Canceled' },
    { value: 'Deleted', color: '#FF0000', label: 'Deleted' },
    { value: 'InnerCampaign', color: '#B6887E', label: 'Inner campaign' },
    { value: 'Metadata', color: '#CCC', label: 'Metadata' },
];